/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
import React from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';

import { format, parseISO } from 'date-fns';

import ActivityList from '@/screens/home/components/ActivityList';
import SociollaText from '@components/sociolla/SociollaText';
import SociollaCard from '@components/sociolla/SociollaCard';
import SociollaList from '@components/sociolla/SociollaList';
import RoundedContent from '@components/global/RoundedContent';

import Colors from '@global/colors';

const Activities = ({ data, style, navigation }) => {
  const noHaveData = !data && data.length;

  const seeAll = () => {
    navigation.navigate('SalesActivityNavigator', {
      screen: 'SalesActivityScreen',
      params: {
        type: 'upcoming_activities',
        titleScreen: 'Upcoming Activities',
      },
    });
  };

  const openDetail = (id) => {
    navigation.navigate('SalesActivityNavigator', {
      screen: 'SalesActivityScreen',
      params: {
        id: id,
      },
    });
  };

  const renderUpcomingActivitiesHeader = () => (
    <View style={styles.upcomingHeader}>
      <SociollaText type="medium" style={{ fontSize: 18 }}>
        Upcoming Activities
      </SociollaText>
      <SociollaText style={styles.seeAllText} onPress={seeAll}>
        see all
      </SociollaText>
    </View>
  );

  const renderNoDataFound = () => (
    <View style={styles.noDataFoundContainer}>
      <SociollaText>No data found</SociollaText>
    </View>
  );

  const renderActivityItemLeft = (visited_at) => (
    <RoundedContent style={styles.upcomingLeft}>
      <LinearGradient
        colors={['#A8D6F2', '#A8D6F2', '#7AA0E1']}
        locations={[0.3388, 0.485, 0.81]}
        start={{ x: 0.5, y: 0 }}
        end={{ x: 0.5, y: 1 }}
        style={styles.upcomingLeftGradient}>
        <SociollaText type="medium" style={{ fontSize: 18 }}>
          {visited_at ? format(parseISO(visited_at), 'dd') : '-'}
        </SociollaText>
        <SociollaText style={{ fontSize: 12 }}>
          {visited_at ? format(parseISO(visited_at), 'MMM') : '-'}
        </SociollaText>
      </LinearGradient>
    </RoundedContent>
  );

  const renderActivityTime = (item) => {
    return item?.start_time && item?.end_time
      ? `${item.start_time} - ${item.end_time}`
      : '-';
  };

  const renderActivityUserTag = (item) => {
    const roleCode = item?.user?.role || item?.user?.role?.code;
    const userName = item?.user?.name;
    if (!roleCode || !userName) {
      return '';
    }

    const roleLabels = {
      salesman: 'Salesman',
      beauty_advisor: 'Beauty Advisor',
      merchandiser: 'Merchandiser',
    };

    const formatFallbackRole = (code) =>
      code.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

    const formattedRole = roleLabels[roleCode] || formatFallbackRole(roleCode);
    return `${formattedRole} - ${userName}`;
  };

  const renderActivityItemRight = (item) => (
    <View style={styles.upcomingRight}>
      <SociollaText style={styles.timeText}>
        {renderActivityTime(item)}
      </SociollaText>
      <SociollaText style={styles.titleText}>{item.title}</SociollaText>
      {renderActivityUserTag(item) ? (
        <SociollaText style={styles.userText} numberOfLines={1}>
          {renderActivityUserTag(item)}
        </SociollaText>
      ) : null}
    </View>
  );

  const renderActivityItem = (x, i) => (
    <SociollaList key={i} index={i}>
      <ActivityList
        left={renderActivityItemLeft(x.visited_at)}
        right={renderActivityItemRight(x)}
        onPress={() => openDetail(x._id)}
      />
    </SociollaList>
  );

  const renderActivityList = (data) => (
    <ScrollView>{data.map((x, i) => renderActivityItem(x, i))}</ScrollView>
  );

  const _getUpcomingActivitiesCardProps = () => ({
    borderColor: Colors.blue2,
    style,
    onPress: seeAll,
    header: renderUpcomingActivitiesHeader(),
  });

  const renderUpcomingActivitiesCard = () => (
    <SociollaCard {..._getUpcomingActivitiesCardProps()}>
      {noHaveData ? renderNoDataFound() : renderActivityList(data)}
    </SociollaCard>
  );

  return renderUpcomingActivitiesCard();
};

const styles = StyleSheet.create({
  upcomingHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  upcomingLeft: {
    height: 50,
    width: 50,
    marginLeft: -12,
    marginRight: 12,
  },
  upcomingLeftGradient: {
    height: '100%',
    width: '100%',
    borderRadius: 5,
    justifyContent: 'center',
    alignItems: 'center',
  },
  upcomingRight: {
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: '100%',
  },
  timeText: {
    fontSize: 12,
    color: Colors.grey1,
    marginBottom: 4,
  },
  titleText: {
    fontSize: 14,
    lineHeight: 17,
  },
  userText: {
    fontSize: 12,
    color: '#5D6DB8',
    marginTop: 4,
  },
  seeAllText: {
    fontSize: 14,
    color: Colors.blue0,
  },
  noDataFoundContainer: { padding: 15 },
});

export default Activities;
